<template>
  <UiAdditionalInformation path="/tilleggsopplysninger/brukerinvolvering" />
</template>
